<template>
<!-- <div>** Scheduler **</div> -->
<div style="" class="deep-orange--text text--darken-1 element-scheduler clickable" @click="scheduleDays(element.scheduleDays)" >
    Schedule for {{element.scheduleDays}} days?
        <div @click.stop>
        <v-menu left offset-y max-height="300">
        <template v-slot:activator="{ on }">
        <v-btn v-on="on" text icon color="deep-orange" style="margin:-3px;">
            <v-icon>arrow_drop_down_circle</v-icon>
        </v-btn>
        </template>
        <v-list>
            <v-list-item @click.stop="scheduleDays(element.scheduleDays)">
                Schedule {{element.scheduleDays}} Days
            </v-list-item>
            <v-list-item @click.stop="scheduleDays(-1)">
                Schedule Custom Date
            </v-list-item>
            <v-list-item @click.stop="scheduleDays(-2)">
                No thanks
            </v-list-item>
            <v-divider></v-divider>
            <template v-for="(menuItem, index) in menuItems">
             <v-list-item v-if="menuItem.days != element.scheduleDays" @click="scheduleDays(menuItem.days)" :key="index">
                {{menuItem.description}}
            </v-list-item>
            </template>
        </v-list>
        </v-menu>
        </div>
</div>
</template>

<script>
import Flag from '../ui-elements/Flag'
import StringHelpers from '../helpers/StringHelpers'
// 


export default {
    data() {
        return {
            menuItems:[
                {days:1, description: '1 day'},
                {days:2, description: '2 days'},
                {days:3, description: '3 days'},
                {days:4, description: '4 days'},
                {days:7, description: '1 week'},
                {days:14, description: '2 weeks'},
                {days:21, description: '3 weeks'},
                {days:30, description: '1 month'},
                {days:60, description: '2 months'},
                {days:90, description: '3 months'},
            ]
        
        }
    },

    components: {
   
    },
    
    props: {
        element: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        scheduleDays(days) {
            this.$store.commit('saveElement', {key: this.element.key, scheduleVisible: false})
            console.log('scheduling for days: ', days)
            let returnElement = {...this.element}
            returnElement.scheduleDays = days
            this.$emit('schedule', returnElement)
        }
    }
}
</script>

<style scoped>
.element-scheduler {
    margin-left:26px;
    display:inline-block;
    border-radius:16px;
    padding: 0px 0px 0px 10px;
    border: solid 1px transparent;
}
.element-scheduler:hover {
    background-color: #FFCCBC;
    border-color: hsl(14, 100%, 78%);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
    transition: all 1s;
}
   
</style>




// WEBPACK FOOTER //
// ElementScheduler.vue?66037cc0